import { GLOBAL_NAV_Z_INDEX } from "@/base/base.constants";

export const navListCss = {
  margin: 0,
  padding: 0,
  width: "100%",
  "> li": {
    listStyle: "none",
  },
  "@media print": {
    display: "none",
  },
};

export const spotlightPopoutCss = {
  maxHeight: "50vh",
};

export const raisedPopoutCss = {
  width: 250,
  maxHeight: "min(450px, calc(100vh - 200px))",
  zIndex: 4,
  "@media (max-width: 770px)": {
    position: "fixed",
    top: "65px",
    left: 0,
    width: "100%",
    zIndex: 6,
  },
};

export const getCssOverrides = (
  isAssignmentPreview,
  bottomNavZIndex,
  topNavZIndex,
) => ({
  height: "auto",
  minHeight: "100%",
  ">li": {
    listStyle: "none",
  },
  main: {
    zIndex: "auto",
  },
  header: {
    ...(isAssignmentPreview ? { paddingLeft: 0, paddingRight: 0 } : {}),
    zIndex: "auto",
    "> div": {
      zIndex: GLOBAL_NAV_Z_INDEX,
      position: "relative",
    },
    nav: {
      zIndex: bottomNavZIndex,
    },
  },
  "& > header > div": {
    zIndex: topNavZIndex,
  },
});

export const getCssOverridesNavRefresh = (
  isAssignmentPreview,
  navMarginBottom,
  headerSize,
  navHeight,
  bottomNavZIndex,
  navFontSize,
) => ({
  height: "auto",
  fontSize: "16px",
  lineHeight: 1,
  ">li": {
    listStyle: "none",
  },
  main: {
    zIndex: "auto",
  },
  header: {
    ...(isAssignmentPreview
      ? { paddingLeft: 0, paddingRight: 0 }
      : { paddingLeft: 16, paddingRight: 16 }),
    zIndex: "auto",
    paddingBottom: navMarginBottom,
    paddingTop: navMarginBottom,
    "> div": {
      zIndex: GLOBAL_NAV_Z_INDEX,
      height: "100%",
      position: "relative",
      fontSize: "0.9rem",
      marginTop: "0px",
      marginBottom: "0px",
      ul: {
        minHeight: headerSize,
        columnGap: "8px",
        justifyContent: "center",
        verticalAlign: "middle",
      },
    },
    button: {
      fontSize: "0.9rem",
      lineHeight: 1,
    },
    "> nav": {
      height: navHeight,
      zIndex: bottomNavZIndex,
      div: {
        fontSize: navFontSize,
      },
      fontSize: navFontSize,
      verticalAlign: "middle",
      "> ul": {
        height: navHeight,
        fontSize: navFontSize,
      },
    },
  },
});
